import { useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';
import { 
  getLocationOptions, 
  getLocationColor 
} from '../../helpers/locations';
import CustomDialog from '../common/CustomDialog';
import CalendarWeekView from './CalendarWeekView';
import SessionForm from '../sessions/SessionForm';

const CalendarScreen = ({
  date,
  sessions,
  onDateChange = (e, date) => console.log('Change date', date),
  calendarView = 'week',
  metrics = [],
  boxStyles = {
    backgroundColor: 'white',
    // overflowY: 'hidden',
    borderRadius: 3,
    boxShadow: 1,
    border: 1,
    borderColor: 'divider',
  },
} = {}) => {
  const [sessionId, setSessionId] = useState(null);
  // console.log('Session_ID', sessionId);
  const selectedSession = sessions?.find(s => s.id === sessionId);
  return (
    <Box style={{paddingLeft: '1em', paddingBottom: '1em'}}>
      <Box style={{paddingBottom: '2em'}}>
        <Stack direction='row' spacing={1}>
          <Typography variant='h1'>Provider Calendar</Typography>
          {/* <Button
            variant='contained'
            color='primary'
            onClick={e => console.log('Add session')}
          >
            <AddIcon/>
            Schedule
          </Button> */}
        </Stack>
      </Box>
      <Grid container spacing={2} p={1}>
        <Grid item sx={12} md={9}>
          {calendarView === 'week' && 
            <CalendarWeekView 
              date={date}
              sessions={sessions}
              boxStyles={boxStyles}
              onDateChange={onDateChange}
              onEditSession={(e, id) => setSessionId(id)}
            />
          }
        </Grid>
        <Grid item sx={12} md={3}>
          <Stack spacing={2}>
            <Box sx={{...boxStyles, p: 2}}>
              <Typography variant='h2'>Location Types</Typography>
              <Stack spacing={0.5} pt={1}>
                {getLocationOptions().map(loc => (
                  <Stack direction='row' spacing={1}>
                    <Box
                      sx={{
                        width: 20, 
                        height: 20, 
                        backgroundColor: getLocationColor(loc.value),
                        borderRadius: 3,
                      }}
                    />
                    <Typography variant='body1'>{loc.label}</Typography>
                  </Stack>
                ))}
              </Stack>
            </Box>
            <Box sx={{...boxStyles, p: 2}}>
              <Typography variant='h2'>This Week</Typography>
              <Stack spacing={2} pt={1}>
                {metrics.map(metric => 
                  <Stack direction='row' spacing={1}>
                    <Typography variant='h1' style={{color: config().colors.secondary}}>
                      {metric.value}
                    </Typography>
                    <Typography variant='body' style={{paddingTop: '0.5em'}}>{metric.label}</Typography>
                  </Stack>
                )}
              </Stack>
            </Box>
          </Stack>
        </Grid>
      </Grid>
      <CustomDialog
        open={!!sessionId}
        onClose={() => setSessionId(null)}
        fullWidth={true}
        maxWidth='md'
        showCloseButton={false}
      >
        {
          selectedSession
          ? <SessionForm
            session={selectedSession}
            isPatient={false}
            onClose={() => setSessionId(null)}
            onSubmitted={() => setSessionId(null)}
          />
          : <></>
        }
      </CustomDialog>
    </Box>
  );
};

export default CalendarScreen;